/**
 * /me/payments/gosi — Session 3d PR 12.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyGosiStatementPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-gosi-statement", employeeId],
    queryFn: () => session3dApi.getGosiStatement(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.gosi-statement.title", "GOSI Statement")}
        subtitle={t("me.gosi-statement.subtitle", "GOSI contribution history + projected pension.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.gosi-statement.title", "GOSI Statement"),
          window_label: t("me.gosi-statement.window", "cumulative + YTD"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.gosi-statement.ask_khidmat", "How much have I contributed to GOSI?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.gosi-statement.detail_note",
                "GOSI contribution YTD + cumulative + projected pension at retirement. Downloadable for personal records.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
